// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/clipboard-list.js';

import { paths } from '../generated/clipboard-list';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('clipboard-list', Original, paths);
